import { computed, onBeforeUnmount, shallowRef, watch } from 'vue';

export interface WebAppViewEntry {
  id: string;
  onBack: () => boolean | void | Promise<boolean | void>;
}

const viewStack = shallowRef<WebAppViewEntry[]>([]);

export const activeWebAppView = computed(() => viewStack.value.at(-1) ?? null);

export function pushWebAppView(entry: WebAppViewEntry) {
  viewStack.value = [...viewStack.value.filter((item) => item.id !== entry.id), entry];
}

export function removeWebAppView(id: string) {
  viewStack.value = viewStack.value.filter((item) => item.id !== id);
}

export function useWebAppView(id: string, visible: () => boolean, onBack: WebAppViewEntry['onBack']) {
  watch(visible, (open) => {
    if (open) pushWebAppView({ id, onBack });
    else removeWebAppView(id);
  }, { immediate: true, flush: 'sync' });
  onBeforeUnmount(() => removeWebAppView(id));
}

export async function navigateBackInWebApp(): Promise<boolean> {
  const entry = activeWebAppView.value;
  if (!entry) return false;
  let keepView = false;
  try {
    keepView = await entry.onBack() === false;
  } finally {
    if (!keepView) removeWebAppView(entry.id);
  }
  return true;
}
